
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/s/ta/[static]",
      function () {
        return require("private-next-pages/cleartax.in/s/ta/[static]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/s/ta/[static]"])
      });
    }
  